<template>
  <div>
    <el-dialog
      :center="true"
      :visible.sync="show"
      :close-on-click-modal="true"
      width="600px"
      class="settingsDialog"
    >
      <!-- <div v-if="showDialog == true" class="a-dialog" v-el-drag-dialog> -->
      <div class="sd_top">
        <div class="sd_t_topTit">切换章节</div>
        <div class="sd_t_right">
          <span @click.stop="close()">×</span>
        </div>
      </div>
      <div class="sd_box">
        <div class="sd_b_list">
          <div
            class="sd_b_l_item"
            v-for="(item, index) in classList"
            :key="index"
          >
            <div class="sd_b_i_title" @click.stop="item.open = !item.open">
              <svg
                width="16"
                height="16"
                viewBox="0 0 16 16"
								:style="item.open?'transform:rotate(0deg)':'transform:rotate(-90deg)'"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M3.54004 6.45977L4.45928 5.54053L7.99966 9.08091L11.54 5.54053L12.4593 6.45977L7.99966 10.9194L3.54004 6.45977Z"
                  fill="black"
                  fill-opacity="0.4"
                />
              </svg>
              <span>{{ item.title }}</span>
            </div>
						<div class="sd_b_i_list" v-if="item.open">
							<div :class="['sd_b_i_l_item',type==`${index}-${index2}`?'sd_b_i_listActive':'']" v-for="(item2,index2) in item.allClass" :key="index+'-'+index2" @click.stop="changeChapter(`${index}-${index2}`)">
								<span>第{{ index2+1 }}节</span><span>{{ item2.title }}</span>
							</div>
						</div>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  props: {},
  data() {
    return {
      show: false,
      classList: [
        {
          title: "第一章：科學入門",
					open:true,
          allClass: [
            {
              title: "學習科學",
              type: 0,
              isComplete: true,
              subject: 4,
              image:
                "https://ccrb.s3.cn-northwest-1.amazonaws.com.cn/%E5%9B%BE%E7%89%8741724834676182.png"
            },
            {
              title: "科學的實踐",
              type: 0,
              subject: 4,
              isComplete: true,
              image:
                "https://ccrb.s3.cn-northwest-1.amazonaws.com.cn/%E5%9B%BE%E7%89%8731724834767532.png"
            },
            {
              title: "實驗室安全",
              type: 0,
              subject: 4,
              isComplete: false,
              image:
                "https://ccrb.s3.cn-northwest-1.amazonaws.com.cn/%E5%9B%BE%E7%89%8721724834685472.png"
            },
            {
              title: "實驗室儀器及基本實驗技巧",
              type: 0,
              subject: 4,
              isComplete: false,
              image:
                "https://ccrb.s3.cn-northwest-1.amazonaws.com.cn/%E5%9B%BE%E7%89%8751724834771676.png"
            },
            {
              title: "綜合練習",
              type: 1,
              subject: 4,
              isComplete: false,
              image:
                "https://ccrb.s3.cn-northwest-1.amazonaws.com.cn/%E5%9B%BE%E7%89%8711724834666052.png"
            }
          ]
        },
        {
          title: "第二章：水",
					open:true,
          allClass: [
            {
              title: "水的物熊變化",
              type: 0,
              subject: 4,
              isComplete: true,
              image:
                "https://ccrb.s3.cn-northwest-1.amazonaws.com.cn/%E5%9B%BE%E7%89%8761724834777931.png"
            },
            {
              title: "水循環",
              type: 0,
              subject: 4,
              isComplete: true,
              image:
                "https://ccrb.s3.cn-northwest-1.amazonaws.com.cn/%E5%9B%BE%E7%89%8771724834845597.png"
            },
            {
              title: "溶解",
              type: 0,
              subject: 4,
              isComplete: true,
              image:
                "https://ccrb.s3.cn-northwest-1.amazonaws.com.cn/%E5%9B%BE%E7%89%8781724834847977.png"
            },
            {
              title: "水的淨化",
              type: 0,
              subject: 4,
              isComplete: true,
              image:
                "https://ccrb.s3.cn-northwest-1.amazonaws.com.cn/%E5%9B%BE%E7%89%8791724834873373.png"
            },
            {
              title: "食水的進一步處理",
              type: 0,
              subject: 4,
              isComplete: false,
              image:
                "https://ccrb.s3.cn-northwest-1.amazonaws.com.cn/%E5%9B%BE%E7%89%8761724834777931.png"
            },
            {
              title: "節約用水和水污染",
              type: 0,
              subject: 4,
              isComplete: false,
              image:
                "https://ccrb.s3.cn-northwest-1.amazonaws.com.cn/%E5%9B%BE%E7%89%8771724834845597.png"
            },
            {
              title: "綜合練習",
              type: 1,
              subject: 4,
              isComplete: false,
              image:
                "https://ccrb.s3.cn-northwest-1.amazonaws.com.cn/%E5%9B%BE%E7%89%8721724834685472.png"
            }
          ]
        },
        {
          title: "第三章：观察生物",
					open:true,
          allClass: [
            {
              title: "生物",
              type: 0,
              isComplete: true,
              subject: 4,
              image:
                "https://ccrb.s3.cn-northwest-1.amazonaws.com.cn/%E5%9B%BE%E7%89%8741724834676182.png"
            },
            {
              title: "生物的分類",
              type: 0,
              subject: 4,
              isComplete: true,
              image:
                "https://ccrb.s3.cn-northwest-1.amazonaws.com.cn/%E5%9B%BE%E7%89%8731724834767532.png"
            },
            {
              title: "檢索表",
              type: 0,
              subject: 4,
              isComplete: false,
              image:
                "https://ccrb.s3.cn-northwest-1.amazonaws.com.cn/%E5%9B%BE%E7%89%8721724834685472.png"
            },
            {
              title: "生物多樣性",
              type: 0,
              subject: 4,
              isComplete: false,
              image:
                "https://ccrb.s3.cn-northwest-1.amazonaws.com.cn/%E5%9B%BE%E7%89%8751724834771676.png"
            },
            {
              title: "綜合練習",
              type: 1,
              subject: 4,
              isComplete: false,
              image:
                "https://ccrb.s3.cn-northwest-1.amazonaws.com.cn/%E5%9B%BE%E7%89%8711724834666052.png"
            }
          ]
        }
      ],
			type:"",
    };
  },
  methods: {
    open(type='2-1') {
      this.show = true;
			this.type = type;
    },
    close() {
      this.show = false;
      this.init();
    },
    init() {
      this.$nextTick(() => {});
    },
		changeChapter(index){
			this.$emit("success",index)
		},
  }
};
</script>

<style scoped>
.settingsDialog >>> .el-dialog {
  min-width: 600px;
  max-width: 80%;
  height: 600px;
  max-height: 80%;
  box-shadow: 0px 0 8px 0px #555555;
  border-radius: 8px;
  background-color: #fff;
  /* top: 0px; */
  /* margin: 0 auto; */
  overflow: hidden;
}
.settingsDialog >>> .el-dialog__body {
  height: 100%;
  min-width: 500px;
  flex-shrink: 0;
  box-sizing: border-box;
  padding-bottom: 50px;
  padding-top: 10px;
}
.settingsDialog >>> .el-dialog__header {
  display: none;
}

.sd_top {
  /* background: #adadad; */
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-items: center;
  justify-content: space-between;
  height: 54px;
  border-radius: 8px 8px 0 0;
  user-select: none;
  font-size: 24px;
  font-weight: bold;
  color: black;
  /* border-bottom: 1px #ccc solid; */
}
.sd_top >>> .el-input__icon {
  line-height: 32px;
}

.sd_t_right {
  cursor: pointer;
}

.sd_box {
  width: 100%;
  padding: 0 30px 20px 30px;
  box-sizing: border-box;
  height: calc(100% - 30px);
}

.sd_b_list {
  width: 100%;
  height: 100%;
  overflow: auto;
}

.sd_b_l_item {
  width: 100%;
  height: auto;
}

.sd_b_i_title {
  width: 100%;
  height: 40px;
  display: flex;
  align-items: center;
  font-size: 20px;
	cursor: pointer;
}

.sd_b_i_title>svg{
	width: 20px;
	height: 20px;
	margin-right: 10px;
}


.sd_b_i_title>span{
	display: flex;
	max-width: 80%;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
}

.sd_b_i_list{
	width: 100%;
	height: auto;
}

.sd_b_i_l_item{
	width: 100%;
	height: 40px;
	border-radius: 4px;
	background-color: #fff;
	font-size: 18px;
	display: flex;
	align-items: center;
	box-sizing: border-box;
	padding-left: 30px;
	margin: 5px 0;
	cursor: pointer;
}

.sd_b_i_l_item>span{
	margin-right: 10px;
}

.sd_b_i_l_item:hover{
	background-color: #E0EAFB;
	color: #3681FC;
	
}

.sd_b_i_listActive{
	background-color: #E0EAFB !important;
	color: #3681FC !important;
}

</style>



// WEBPACK FOOTER //
// src/components/pages/pocAiClassroom/component/changeChapterDialog.vue